import React from 'react'
import {Lang} from 'yougile-lang'

export const TextStates = () => (
  <div className="flex flex-col gap-8 py-8">
    <div className="text-sm-semibold">{Lang.msg.myStickers.states}</div>
    <div className="text-sm-regular">
      {Lang.msg.myStickers.textStickerStates}
    </div>
  </div>
)
